module.exports = __webpack_public_path__ + "img/2.cf4ebb6c.jpg";